import { motion } from "framer-motion";
import { fadeRise, stagger, viewport, viewportGroup } from "@/hooks/useReveal";

export const Reveal = ({ children, i = 0, className = "", as: Tag = "div", ...rest }) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      variants={fadeRise}
      custom={i}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export const RevealGroup = ({ children, className = "", ...rest }) => (
  <motion.div
    variants={stagger}
    initial="hidden"
    whileInView="show"
    viewport={viewportGroup}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className = "", ...rest }) => (
  <motion.div variants={fadeRise} className={className} {...rest}>
    {children}
  </motion.div>
);
